function cov_1ztovhr6l5() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/helpers/googleMaps.ts";
  var hash = "39cb91b43c02b1f7b2799323f2973ba0f5d2169d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/helpers/googleMaps.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 26
        },
        end: {
          line: 5,
          column: 49
        }
      },
      "1": {
        start: {
          line: 7,
          column: 29
        },
        end: {
          line: 7,
          column: 81
        }
      },
      "2": {
        start: {
          line: 9,
          column: 46
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "3": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 72
        }
      },
      "4": {
        start: {
          line: 13,
          column: 36
        },
        end: {
          line: 15,
          column: 1
        }
      },
      "5": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 14,
          column: 89
        }
      },
      "6": {
        start: {
          line: 17,
          column: 30
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "7": {
        start: {
          line: 28,
          column: 18
        },
        end: {
          line: 28,
          column: 46
        }
      },
      "8": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 31,
          column: 3
        }
      },
      "9": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 53
        }
      },
      "10": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 70
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 46
          },
          end: {
            line: 9,
            column: 47
          }
        },
        loc: {
          start: {
            line: 9,
            column: 52
          },
          end: {
            line: 11,
            column: 1
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 13,
            column: 36
          },
          end: {
            line: 13,
            column: 37
          }
        },
        loc: {
          start: {
            line: 13,
            column: 77
          },
          end: {
            line: 15,
            column: 1
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 17,
            column: 30
          },
          end: {
            line: 17,
            column: 31
          }
        },
        loc: {
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 33,
            column: 1
          }
        },
        line: 27
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 3,
            column: 26
          },
          end: {
            line: 5,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 4,
            column: 4
          },
          end: {
            line: 4,
            column: 21
          }
        }, {
          start: {
            line: 5,
            column: 4
          },
          end: {
            line: 5,
            column: 49
          }
        }],
        line: 3
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 29
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "39cb91b43c02b1f7b2799323f2973ba0f5d2169d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ztovhr6l5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1ztovhr6l5();
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.max-safe-integer.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { isProductionEnv } from "./globals.mjs";
var ADDRESS_INPUT_URL = (cov_1ztovhr6l5().s[0]++, isProductionEnv() ? (cov_1ztovhr6l5().b[0][0]++, '/_address-input') : (cov_1ztovhr6l5().b[0][1]++, 'https://demo.simplersell.com/_address-input'));
export var ALLOWED_TYPES = (cov_1ztovhr6l5().s[1]++, ['street_address', 'premise', 'subpremise', 'route']);
cov_1ztovhr6l5().s[2]++;
export var generateGoogleMapsSessionToken = function generateGoogleMapsSessionToken() {
  cov_1ztovhr6l5().f[0]++;
  cov_1ztovhr6l5().s[3]++;
  return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
};
cov_1ztovhr6l5().s[4]++;
export var buildAutocompleteUrl = function buildAutocompleteUrl(query, sessionToken) {
  cov_1ztovhr6l5().f[1]++;
  cov_1ztovhr6l5().s[5]++;
  return "".concat(ADDRESS_INPUT_URL, "/autocomplete?sessionToken=").concat(sessionToken, "&query=").concat(query);
};
cov_1ztovhr6l5().s[6]++;
export var buildPlacesUrl = function buildPlacesUrl(_ref) {
  var source = _ref.source,
    placeId = _ref.placeId,
    addressToken = _ref.addressToken,
    sessionToken = _ref.sessionToken;
  cov_1ztovhr6l5().f[2]++;
  var baseUrl = (cov_1ztovhr6l5().s[7]++, "".concat(ADDRESS_INPUT_URL, "/place"));
  cov_1ztovhr6l5().s[8]++;
  if (source === 'casa') {
    cov_1ztovhr6l5().b[1][0]++;
    cov_1ztovhr6l5().s[9]++;
    return baseUrl + "?addressToken=".concat(addressToken);
  } else {
    cov_1ztovhr6l5().b[1][1]++;
  }
  cov_1ztovhr6l5().s[10]++;
  return baseUrl + "?sessionToken=".concat(sessionToken, "&placeId=").concat(placeId);
};
//# sourceMappingURL=googleMaps.mjs.map